import * as React from 'react'

import { css } from '@emotion/react'
import styled from '@emotion/styled'

import Input from './Input'

const Wrapper = styled.span`
  position: relative;
  display: flex;

  ${props => props.theme.breakpoints.tablet} {
    max-width: ${props => props.theme.maxWidths.field};
  }
`

const CurrencyPrefix = styled.span<{ disabled?: boolean }>`
  position: absolute;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  line-height: 3rem;
  font-size: 1.1rem;
  font-weight: ${props => props.theme.weights.regular};

  padding: 0 1.375rem;
  height: 100%;

  ${props =>
    props.disabled &&
    css`
      color: ${props.theme.colors.disabledLabel};
    `}
`

type CurrencyInputProps = {
  showCurrencyPrefix?: boolean
  wrapperRef: React.Ref<HTMLSpanElement>
} & React.ComponentProps<typeof Input>

const CurrencyInput = ({ disabled, showCurrencyPrefix = true, wrapperRef, ...props }: CurrencyInputProps) => (
  <Wrapper ref={wrapperRef}>
    {showCurrencyPrefix && (
      <CurrencyPrefix className="currency-prefix" disabled={disabled}>
        $
      </CurrencyPrefix>
    )}
    <PaddedTextInput disabled={disabled} showCurrencyPrefix={showCurrencyPrefix} {...props} />
  </Wrapper>
)

const PaddedTextInput = styled(Input)<{ showCurrencyPrefix: boolean }>`
  appearance: none;
  width: 100%;
  padding-left: ${props => props.showCurrencyPrefix && '3rem'};

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  -moz-appearance: textfield;
`

export default CurrencyInput
